import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'

import Scrollbar from '../../components/scrollbar'
import { useParams } from 'react-router-dom'
import projects from '../../api/projects'
import Logo from '../../images/logo.png'
import Footer from '../../components/footer';
import ProyectSingle from '../../components/ProjectDetails';
import ProyectTitle from '../../components/ProyectTitle';
import ProyectPageSelector from '../../components/ProjectPageSelector';

const ProjectDetails =() => {

    const [page, setPage] = React.useState([0]);
    const { id } = useParams()

    const BlogDetails = projects.find(item => item.id === id)

    return(
        <Fragment>
            <Navbar Logo={Logo}/>
             <ProyectTitle pageTitle={BlogDetails.mainTitle} bgClass={BlogDetails.bgClass} pagesub={BlogDetails.title}/> 
             <ProyectPageSelector pages={BlogDetails.pages} setPage={setPage}></ProyectPageSelector>
             <ProyectSingle page={page}  />
             <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ProjectDetails;
